// RBAC roles — PSD §11.3 (F11.1). State layer.

export type Role = 'editor' | 'viewer' | 'reviewer' | 'approver';

export type Permission =
  | 'valuation:create'
  | 'valuation:edit'
  | 'valuation:run'
  | 'valuation:delete'
  | 'signoff:submit'
  | 'signoff:approve'
  | 'settings:edit'
  | 'export:download';

const ROLE_PERMISSIONS: Record<Role, Permission[]> = {
  viewer: ['export:download'],
  editor: ['valuation:create', 'valuation:edit', 'valuation:run', 'export:download'],
  reviewer: [
    'valuation:create',
    'valuation:edit',
    'valuation:run',
    'signoff:submit',
    'export:download',
  ],
  approver: [
    'valuation:create',
    'valuation:edit',
    'valuation:run',
    'signoff:submit',
    'signoff:approve',
    'settings:edit',
    'export:download',
  ],
};

export function hasPermission(role: Role, perm: Permission): boolean {
  return ROLE_PERMISSIONS[role]?.includes(perm) ?? false;
}

export function canApprove(role: Role): boolean {
  return role === 'reviewer' || role === 'approver';
}
